import { Box, Typography } from "@mui/material";
import React from "react";

const NoDataFound = ({mt}) => {
  return (
    <Box
          sx={{
            display: "flex",
            justifyContent: "center", // horizontally center
            alignItems: "center", // vertically center
            }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "inter",
              color: "#d3d3d3",
              fontWeight: "bold",
              m:"8%",
              mt:mt
            }}
          >
            No Data Found
          </Typography>
        </Box>
  );
};

export default NoDataFound;
